/// <amd-module name="Search/Code/Components/Notification" />
import * as Resources from "Search/Code/Resources";
import * as SharedResources from "Search/Shared/Resources";
import * as Constants from "Search/Code/Constants";
import { IndexingBanner, QueryState, StaleFileBanner } from "Search/Code/Flux/Stores/NotificationStore";
import { IAggregatedState } from "Search/Code/Flux/StoresHub";
import { ActionCreator } from "Search/Code/Flux/ActionCreator";
import { ObservableValue } from "VSS/Core/Observable";
import { INotificationProps } from "Search/Shared/Components/NotificationArea";
import { MessageBarSeverity } from "VSSUI/MessageBar";

export function handlePivotNotification(
    pageNotification: ObservableValue<INotificationProps>,
    getAggregatedState: () => IAggregatedState,
    actionCreator: ActionCreator) {
    const { notificationStoreState } = getAggregatedState();
    const { indexingBannerState, searchQueryState, fileBannerState } = notificationStoreState;
    const { clickLearnMoreLinkForPartialResults, publishNotificationBanner, dismissNotificationBanner } = actionCreator;
    const message =
        indexingBannerState === IndexingBanner.AccountIndexing
            ? SharedResources.AccountIsGettingIndexedBannerMessage
            : indexingBannerState === IndexingBanner.BranchIndexing
                ? Resources.BranchesAreBeingIndexed : "";

    if (message) {
        // Handle indexing scenarios
        pageNotification.value = {
            visible: true,
            isFormatted: false,
            severity: MessageBarSeverity.Warning,
            message,
            onDismiss: dismissNotificationBanner
        }

        publishNotificationBanner(IndexingBanner[notificationStoreState.indexingBannerState]);
    } else if (searchQueryState === QueryState.TimedOut) {
        // Handle partial results scenario in case of query time outs.
        pageNotification.value = {
            visible: true,
            isFormatted: true,
            severity: MessageBarSeverity.Info,
            message: Resources.ShowingPartialResultsWithQueryTimeOut,
            link: Constants.PartialResultsForCodeBlogLink,
            onLinkClick: clickLearnMoreLinkForPartialResults,
            linkLabel: SharedResources.LearnMoreLabelForPartialResults,
            onDismiss: dismissNotificationBanner
        };
        publishNotificationBanner(QueryState[notificationStoreState.searchQueryState]);
    }
    else if (fileBannerState === StaleFileBanner.StaleFile) {
       // Handle stale branch scenarios
        pageNotification.value = {
            visible: true,
            isFormatted: true,
            severity: MessageBarSeverity.Warning,
            message: Resources.StaleBranchNotification,
            link: Constants.CodexDevCommunityLink,
            linkLabel: Resources.LinkLabelForStaleBranchReporting,
            onDismiss: dismissNotificationBanner
        };
        publishNotificationBanner(QueryState[notificationStoreState.searchQueryState]);
    }
    else {
        // dispose notification if none of indexing is in progress, or partial results are obtained.
        pageNotification.value = {
            ...pageNotification.value,
            visible: false
        }
    }
}